import { DotsSixVerticalIcon } from '@phosphor-icons/react';
import type {
    DraggableAttributes,
    DraggableSyntheticListeners,
} from '@dnd-kit/core';
import type { Ref } from 'react';
import { cn } from '@/lib/utils';

interface ReportPromptDragHandleProps {
    label: string;
    testId: string;
    attributes: DraggableAttributes;
    listeners: DraggableSyntheticListeners;
    ref: Ref<HTMLButtonElement>;
}

export function ReportPromptDragHandle({
    label,
    testId,
    attributes,
    listeners,
    ref,
}: ReportPromptDragHandleProps) {
    return (
        <button
            ref={ref}
            type="button"
            aria-label={label}
            data-testid={testId}
            className={cn(
                'absolute -left-6 top-0 flex h-5 w-5 items-center justify-center rounded-[4px]',
                'text-grey-300 hover:bg-surface-hover hover:text-white-100',
                'cursor-grab active:cursor-grabbing',
                'opacity-0 transition-opacity group-hover/report-prompt:opacity-100',
                'focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-grey-400',
            )}
            {...attributes}
            {...listeners}
        >
            <DotsSixVerticalIcon className="h-4 w-4" weight="bold" />
        </button>
    );
}
